import Vue from 'vue'
import store from './store'
import {permissions} from '@/constants/permissions'

/**
 * 操作权限鉴权指令
 * @type {DirectiveOptions}
 */
Vue.directive('ioriPermission', {
    inserted: function (el, binding) {
        // 获取页面按钮权限
        let permissionCode = binding.value;
        if (!Vue.prototype.$ioriPermission(permissionCode)) {
            el.parentNode.removeChild(el);
        }
    }
});

/**
 * 操作权限鉴权方法
 * @param permissionCode 待鉴权的权限编码
 * @returns {boolean} true: 有权限；false: 无权限
 */
Vue.prototype.$ioriPermission = function (permissionCode) {
    // 如果待鉴权的权限编码为空，则表示无需鉴权，返回true
    if (!permissionCode) {
        return true;
    }
    // 权限检测配置,前端按钮做权限检测时，如果配置为"IgnoreAll"，则放开所有权限检测
    // if ("IgnoreAll" == checkPermission) {
    //     return true;
    // }
    let havePermissions = store.getters.havePermissions;
    // 鉴权
    let _valid = function (p) {
        for(let i = 0; i < havePermissions.length; i++) {
            if(p == havePermissions[i]) {
                return true;
            }
        }
        return false;
    }
    return _valid(permissionCode);
};

/**
 * 当前系统所有操作权限编码集合
 */
Vue.prototype.$ALLPERMISSIONS = permissions;
